import { LngLat, type LngLatLike } from 'maplibre-gl'
import { jwt } from '$utils/jwt'
import { get } from 'svelte/store'

// Documentation: https://developers.google.com/maps/documentation/routes/reference/rest/v2/TopLevel/computeRoutes?hl=de

const JWT_GOOGLE_MAPS_API_KEY = 'google_maps_apikey'
const URL = 'https://routes.googleapis.com/directions/v2:computeRoutes'

function convertLngLatLike(coordinates: LngLatLike) {
	const { lng, lat } = LngLat.convert(coordinates)
	return { latitude: lat, longitude: lng }
}

export async function computePolylineRoute(
	origin: LngLatLike,
	destination: LngLatLike,
	intermediateStops?: LngLatLike[]
) {
	const api = get(jwt)[JWT_GOOGLE_MAPS_API_KEY]

	let intermediates: { location: { latLng: { latitude: number; longitude: number } } }[] = []
	if (intermediateStops) {
		intermediates = intermediateStops.map((intermediate) => ({
			location: { latLng: convertLngLatLike(intermediate) }
		}))
	}

	const body = {
		origin: { location: { latLng: convertLngLatLike(origin) } },
		destination: { location: { latLng: convertLngLatLike(destination) } },
		intermediates,
		travelMode: 'DRIVE',
		routingPreference: 'TRAFFIC_AWARE',
		polylineEncoding: 'GEO_JSON_LINESTRING',
		computeAlternativeRoutes: false
	}

	const fieldMask = [
		'routes.distanceMeters',
		'routes.duration',
		'routes.polyline.geoJsonLinestring'
	].join(',')

	const res = await fetch(URL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Goog-Api-Key': api,
			'X-Goog-FieldMask': fieldMask
		},
		body: JSON.stringify(body)
	})

	if (!res.ok) {
		const text = await res.text()
		throw new Error(`Routes API error ${res.status}: ${text}`)
	}

	const route = (await res.json())?.routes?.[0]
	const distanceMeters = route?.distanceMeters
	const duration = route?.duration
	const polyline = route?.polyline?.geoJsonLinestring?.coordinates
	return { distanceMeters, duration, polyline }
}
